"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.writeToDatabase = exports.performShare = exports.normalizePrices = exports.bookmarkDelete = exports.bookmarkAdd = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));
var _database = require("../database");
var _jspdf = require("jspdf");
var _jspdfAutotable = _interopRequireDefault(require("jspdf-autotable"));
/*
 * Normalize the prices, from the object into array
 * @param { Object } data
 * Example: {sagar: { chali: '2022-09-12': { minimum: 1, maximum: 1, modal: 1, arrivals: 1}}}
 */
var normalizePrices = function normalizePrices(data) {
  var markets = new Map();
  var varieties = new Map();
  var result = {
    prices: [],
    markets: [],
    varieties: []
  };
  for (var market in data) {
    markets.set(market.toLowerCase(), market.toLowerCase());
    if (!varieties.has(market)) {
      varieties.set(market, new Map());
    }
    for (var variety in data[market]) {
      varieties.get(market.toLowerCase()).set(variety.toLowerCase(), variety.toLowerCase());
      var previous = null;
      for (var date in data[market][variety]) {
        var price = {
          date: date,
          market: market,
          variety: variety,
          minimum: Number(data[market][variety][date].minimum),
          maximum: Number(data[market][variety][date].maximum),
          modal: Number(data[market][variety][date].modal),
          arrivals: Number(data[market][variety][date].arrivals)
        };
        // Apply calculations if it's second element
        // FIXME: Currently I am assuming data is sorted at the server, the last element in a variety will be the recent and first one will be the oldest.
        // This may go wrong, if server or origin changes the logic. Be careful
        if (previous) {
          price.changeMinimum = price.minimum - previous.minimum;
          price.changeMaximum = price.maximum - previous.maximum;
          price.changeModal = price.modal - previous.modal;
          price.changeArrivals = price.arrivals - previous.arrivals;
          price.changeMinimumPercentage = (price.minimum - previous.minimum) / previous.minimum * 100;
          price.changeMaximumPercentage = (price.maximum - previous.maximum) / previous.maximum * 100;
          price.changeModalPercentage = (price.modal - previous.modal) / previous.modal * 100;
          price.changeArrivalsPercentage = (price.arrivals - previous.arrivals) / previous.arrivals * 100;
        } else {
          price.changeMinimum = 0;
          price.changeMaximum = 0;
          price.changeModal = 0;
          price.changeArrivals = 0;
          price.changeMinimumPercentage = 0;
          price.changeMaximumPercentage = 0;
          price.changeModalPercentage = 0;
          price.changeArrivalsPercentage = 0;
        }
        previous = price;
        result.prices.push(price);
      }
    }
  }
  var _iterator = (0, _createForOfIteratorHelper2.default)(markets),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      result.markets.push({
        id: key,
        name: value
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = (0, _createForOfIteratorHelper2.default)(varieties),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = (0, _slicedToArray2.default)(_step2.value, 2),
        _market = _step2$value[0],
        values = _step2$value[1];
      var _iterator3 = (0, _createForOfIteratorHelper2.default)(values),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = (0, _slicedToArray2.default)(_step3.value, 1),
            _value = _step3$value[0];
          result.varieties.push({
            market: _market,
            name: _value,
            id: _value
          });
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return result;
};
exports.normalizePrices = normalizePrices;
var writeToDatabase = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(data) {
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _database.database.prices.bulkPut(data.prices);
          case 2:
            _context.next = 4;
            return _database.database.markets.bulkPut(data.markets);
          case 4:
            _context.next = 6;
            return _database.database.varieties.bulkPut(data.varieties);
          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function writeToDatabase(_x) {
    return _ref.apply(this, arguments);
  };
}();
exports.writeToDatabase = writeToDatabase;
var bookmarkAdd = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(market, variety) {
    var bookmark;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            bookmark = {
              market: market,
              variety: variety
            };
            _context2.next = 3;
            return _database.database.bookmarks.add(bookmark);
          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function bookmarkAdd(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
exports.bookmarkAdd = bookmarkAdd;
var bookmarkDelete = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(bookmark) {
    return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _database.database.bookmarks.where('market').equals(bookmark.market).and(function (elem) {
              return elem.variety === bookmark.variety;
            }).delete();
          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function bookmarkDelete(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
exports.bookmarkDelete = bookmarkDelete;
var performShare = function performShare(prices, market, variety, dates, t) {
  var doc = new _jspdf.jsPDF({
    unit: 'pt'
  });

  // [t('intlDateLong', { val: new Date(prices.at(-1).date)}) + ' ' + t('to') + ' ' + t('intlDateLong', { val: new Date(prices.at(0)).date})],    
  (0, _jspdfAutotable.default)(doc, {
    head: [[t('date'), t('market'), t('variety'), t('maximum'), t('minimum'), t('modal'), t('arrivals')]],
    body: prices.map(function (item) {
      return [t('intlDateLong', {
        val: new Date(item.date)
      }), t(market), t(variety), t('intlCurrencyShort', {
        val: item.maximum
      }), t('intlCurrencyShort', {
        val: item.minimum
      }), t('intlCurrencyShort', {
        val: item.modal
      }), item.arrivals];
    })
  });
  var file = doc.output('blob');
  void function () {
    var _share = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
      var name, files, data, canShare;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              name = "".concat(market, "_").concat(variety, ".pdf");
              files = [new File([file], name, {
                type: file.type
              })];
              data = {
                files: files,
                title: t('report'),
                text: "".concat(t(market), " - ").concat(t(variety)),
                url: 'https://play.google.com/store/apps/details?id=com.nerdlabs.arecanut' // FIXME: Use Playstore url from env
              };
              canShare = navigator.canShare(data);
              if (!canShare) {
                _context4.next = 13;
                break;
              }
              _context4.prev = 5;
              _context4.next = 8;
              return navigator.share(data);
            case 8:
              _context4.next = 13;
              break;
            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](5);
              // TODO: show message
              console.log(_context4.t0);
            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[5, 10]]);
    }));
    function share() {
      return _share.apply(this, arguments);
    }
    return share;
  }()();
};
exports.performShare = performShare;